// components/RAGBadge.js
// Reusable RAG stage indicator — used on deal list rows, detail page,
// and introducer pipeline view.
//
// Props:
//   stageName   string   — e.g. "Offer Received"
//   ragColour   string   — 'red' | 'amber' | 'green'
//   size        string   — 'sm' | 'md' (default 'md')
//   showDot     bool     — show coloured dot only (no label), default false

import React from 'react';

const RAG = {
  red:   { bg: '#fee2e2', border: '#fca5a5', text: '#991b1b', dot: '#ef4444' },
  amber: { bg: '#fef3c7', border: '#fcd34d', text: '#92400e', dot: '#f59e0b' },
  green: { bg: '#d1fae5', border: '#6ee7b7', text: '#065f46', dot: '#10b981' },
};

export default function RAGBadge({ stageName, ragColour, size = 'md', showDot = false }) {
  const c = RAG[ragColour] || RAG.amber;

  if (showDot) {
    return (
      <span
        title={stageName ? `${stageName} (${ragColour})` : ragColour}
        style={{
          display:      'inline-block',
          width:        size === 'sm' ? 8 : 10,
          height:       size === 'sm' ? 8 : 10,
          borderRadius: '50%',
          background:   c.dot,
          flexShrink:   0,
        }}
      />
    );
  }

  return (
    <span style={{
      display:      'inline-flex',
      alignItems:   'center',
      gap:          6,
      fontSize:     size === 'sm' ? 11 : 12,
      fontWeight:   600,
      padding:      size === 'sm' ? '2px 8px' : '3px 10px',
      borderRadius: 20,
      background:   c.bg,
      border:       `1px solid ${c.border}`,
      color:        c.text,
      whiteSpace:   'nowrap',
    }}>
      <span style={{
        width: 7, height: 7, borderRadius: '50%',
        background: c.dot, flexShrink: 0,
      }} />
      {stageName || ragColour}
    </span>
  );
}
